// @flow
import { EnlacesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    enlace: {},
    listaEnlaces: [],
    loading: false,
    error: false,
    formSubmited: false
};

type EnlacesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { enlace?: {} | null, listaEnlaces?: [] | null, loading?: boolean, +value ?: boolean };

const Enlaces = (state: State = INIT_STATE, action: EnlacesAction): any => {
    // console.log(action);
    switch (action.type) {
        case EnlacesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EnlacesActionTypes.GET_ENLACE: {
                    return {
                        ...state,
                        enlace: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EnlacesActionTypes.LIST_ENLACES: {
                    return {
                        ...state,
                        listaEnlaces: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EnlacesActionTypes.ADD_ENLACE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EnlacesActionTypes.UPDATE_ENLACE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EnlacesActionTypes.DELETE_ENLACE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EnlacesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EnlacesActionTypes.GET_ENLACE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        enlace: {},
                        loading: false,
                    };
                }
                case EnlacesActionTypes.LIST_ENLACES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaEnlaces: [],
                        loading: false,
                    };
                }
                case EnlacesActionTypes.ADD_ENLACE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EnlacesActionTypes.UPDATE_ENLACE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EnlacesActionTypes.DELETE_ENLACE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EnlacesActionTypes.GET_ENLACE:
            return { ...state, error: false, loading: true };
        case EnlacesActionTypes.LIST_ENLACES:
            return { ...state, error: false, loading: true };
        case EnlacesActionTypes.ADD_ENLACE:
            return { ...state, error: false, loading: true };
        case EnlacesActionTypes.UPDATE_ENLACE:
            return { ...state, error: false, loading: true };
        case EnlacesActionTypes.DELETE_ENLACE:
            return { ...state, error: false, loading: true };
        case EnlacesActionTypes.RESET:
            return {
                ...state,
                enlace: {},
                listaEnlaces: [],
                loading: false,
                error: false,
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Enlaces;
